export default __webpack_public_path__ + "1e92e94.png";